import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
// import Loading from 'components/Loading';
import Icon from "components/Icons/Icon";
import Select, { components } from 'react-select';

import './AddAssetCompany.scss';

import conxtdOut from 'apis/conxtdOut';
// import Axios from '../../../../../node_modules/axios/index';

import { loadCompanyAssetsStart } from "services/redux/actions/serviceDesk";
import { getCompanyAssetFields } from 'services/redux/selectors/serviceDesk/assets';
import { getCompanyIdFromRoute } from 'services/redux/selectors/company';
import { useIsMounted } from 'components/Common/CustomHooks/useIsMounted';
import AddSiteAsset from './CompanyAssetManager/AddSiteAsset/AddSiteAsset';
import CategorySelection from './CompanyAssetManager/AddSiteAsset/CategorySelection';

import { darkModeSelectStyles } from "components/Common/CustomStyles/darkModeSelectStyles";
import { _, debounce } from "lodash";

// Custom Options for Select Components ----->
// Custom Site Select Options:
const SiteCustomOption = (props) => {
  const { company, site_ref, transmitter_ref, address1, address2, town, postcode, contract_number } = props?.data?.keys;

  const [addressNull, setAddressNull] = useState(false);

  useEffect(() => {
    setAddressNull(!address1 && !address2 && !town);
  }, [address1, address2, town])

  const address = [
    address1,
    address2,
    town,
  ].filter(Boolean).join(', ');

  return (
    <components.Option {...props} key={props?.data?.id}>
      <Row className='d-flex align-items-center flex-row px-3 custom-option-row'>
        <Col lg={2} title='Site Name' className="custom-option-cell font-weight-bold">{company ?? ''}</Col>

        <Col lg={2} title='Site Ref' className="custom-option-cell">{site_ref ?? ''}</Col>

        <Col lg={2} title='Transmitter Ref' className="custom-option-cell">{transmitter_ref ?? ''}</Col>

        <Col lg={2} title='Address' className="custom-option-cell">{address}</Col>

        <Col lg={2} title='Postcode' className="custom-option-cell centred">{postcode ?? ''}</Col>

        <Col title='Contract Number' className="custom-option-cell centred">{contract_number ?? ''}</Col>

      </Row>
    </components.Option>
  );
};

// sudo site search and selection component
const SiteSelection = ({ companyId, handleSetSudoSiteId, handleSetMctClusterId, handleSetMobileAppId, handleSetSiteSelectionInvalid, darkMode }) => {
  const [siteInput, setSiteInput] = useState('');
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSite, setSelectedSite] = useState([]);

  const isMounted = useIsMounted();
  
  useEffect(() => {
    if (!isMounted) { return };

    if (companyId && siteInput) {
      
      const sites = conxtdOut.get(`/company-assets/company-sites/${companyId}?search=${siteInput}`)
      
      sites.then((res) => {
        if (!res?.data) { return };
        const sites = res?.data;
        const options = sites.map(site => {
          if (!site.id || !site.company) return null;

          const {
            id,
            company,
            site_ref,
            transmitter_ref,
            address1,
            address2,
            town,
            postcode,
            contract_number,
            mct_cluster_id,
            mobile_app_id,
          } = site ?? {};

          const buildSiteLabel = (site) => [
            site.company ?? '',
            site.site_ref ?? '',
            site.transmitter_ref ?? '',
            site.address1 ?? '',
            site.address2 ?? '',
            site.town ?? '',
            site.postcode ?? '',
            site.contract_number ?? '',
          ].filter(Boolean).join(' | ');
          
          return { 
            label: buildSiteLabel(site),
            value: site.id,
            keys: {
              id,
              company,
              site_ref,
              transmitter_ref,
              address1,
              address2,
              town,
              postcode,
              contract_number,
              mct_cluster_id,
              mobile_app_id,
            },
          }
        });

        setSiteOptions(options);
      });
    }

    if (!siteInput && Array.isArray(selectedSite) && selectedSite.length < 1) {
      setSiteOptions([]);
    }
  }, [companyId, siteInput, selectedSite])
  
  useEffect(() => {
    if (!isMounted) { return };
    handleSetSudoSiteId(selectedSite?.[0]?.value ?? null)
  }, [selectedSite])

  useEffect(() => {
    handleSetSiteSelectionInvalid(Array.isArray(selectedSite) && selectedSite.length < 1);
  }, [selectedSite])
  
  return (
    <>
      <Col className={`d-flex flex-column p-0 `}>
        <span className='d-flex flex-column'>
          <p>Search for and select the <span className='add-asset-sub-title'>site</span> to assign this new asset to:</p>
        </span>
        <Select
          data-intercom-target={"add-site-mobile-app-select"}
          name="site_selection"
          id="site_selection"
          options={siteOptions}
          components={{ Option: SiteCustomOption }}
          isClearable={selectedSite.length > 0 ?? false}
          maxMenuHeight={400}
          placeholder={'Enter site details e.g. Name, Site Ref, Address...'}
          onChange={(e) => {
            const {
              company,
              mct_cluster_id,
              mobile_app_id,
            } = e?.keys ?? {};

            setSelectedSite(!e ? [] : [{ label: company ?? '', value: e?.value ?? '' }]);
            handleSetMctClusterId(mct_cluster_id ?? null);
            handleSetMobileAppId(mobile_app_id ?? null);
          }}
          onInputChange={debounce((e) => {
            const value = String(e);
            if (value) {
              setSiteInput(value);
            }
            if (!value && siteInput.length === 1) {
              setSiteInput(value);
            }
            if (!value) {setSiteInput('')}
          }, 300)}
          value={selectedSite}
          styles={{
            ...(darkMode ? darkModeSelectStyles : {}),
            option: (provided, state) => ({
              ...provided, 
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            container: (base) => ({
              ...base,
              position: 'relative',
              zIndex: 9999,
            }),
          }}
        />
      </Col>
    </>
  )
}

function AddAssetCompany({ showAddSiteAssetModal, handleModalShow, handleModalClose }) {
  const dispatch = useDispatch();

  const { darkMode } = useSelector((state) => state.app)
  const companyAssetFields = useSelector(getCompanyAssetFields);
  const companyId = useSelector(getCompanyIdFromRoute);

  const [sudoSiteId, setSudoSiteId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [mctClusterId, setMctClusterId] = useState(null);
  const [mobileAppId, setMobileAppId] = useState(null);
  const [categoryCustomFields, setCategoryCustomFields] = useState([]);
  
  // const [showAddSiteAssetModal, setShowAddSiteAssetModal] = useState(false);
  
  const [siteSelectionInvalid, setSiteSelectionInvalid] = useState(true);
  const [categorySelectionInvalid, setCategorySelectionInvalid] = useState(true);

  useEffect(() => {
    dispatch(loadCompanyAssetsStart({ companyId }));
  }, [companyId])

  // const handleModalShow = () => {
  //   setShowAddSiteAssetModal(true);
  // }

  // const handleModalClose = () => {
  //   setShowAddSiteAssetModal(false);
  // }
  
  const handleSetMctClusterId = (value) => {
    setMctClusterId(value ?? null);
  }

  const handleSetMobileAppId = (value) => {
    setMobileAppId(value ?? null);
  }
  
  const handleSetSudoSiteId = (value) => {
    setSudoSiteId(value ?? null);
  }
  
  const handleSetCategoryId = (value) => {
    setCategoryId(value ?? null);
  }
  
  const handleSetCustomFields = (value) => {
    setCategoryCustomFields(value ?? null);
  }
  
  const handleSetSiteSelectionInvalid = (value) => {
    setSiteSelectionInvalid(value);
  }

  const handleCategorySelectionInvalid = (value) => {
    setCategorySelectionInvalid(value);
  }

  return (
    <>
      <div 
        className='d-flex justify-content-start align-items-center'
        // onClick={() => {
        //   handleModalShow()
        // }}
      >
        <span><Icon className="fas fa-plus mr-2 dropdown-icon text-center" title="Add Single Asset" />Add Single Asset</span>
      </div>

      <AddSiteAsset
        key={'add-site-asset-modal'}
        siteSelectionInvalid={siteSelectionInvalid}
        categorySelectionInvalid={categorySelectionInvalid}
        additionalSections={[
          {
            id: 'site_selection',
            name: 'Site Details *',
            component:
            <SiteSelection 
              companyId={companyId}
              handleSetSudoSiteId={handleSetSudoSiteId}
              handleSetMctClusterId={handleSetMctClusterId}
              handleSetMobileAppId={handleSetMobileAppId}
              handleSetSiteSelectionInvalid={handleSetSiteSelectionInvalid}
              darkMode={darkMode}
            />
          },
          {
            id: 'asset_category',
            name: 'Asset Category *',
            invalid: categorySelectionInvalid,
            component:
              <CategorySelection
                key={'category'} 
                companyId={companyId}
                handleSetCategoryId={handleSetCategoryId}
                handleSetCustomFields={handleSetCustomFields}
                handleCategorySelectionInvalid={handleCategorySelectionInvalid}
                darkMode={darkMode}
              />
          }
        ]}
        siteAssetFields={
          Array.isArray(companyAssetFields) && companyAssetFields.length > 0
            ? companyAssetFields.map(field => ({
                ...field,
                config: { ...field.config },
                default: true
              }))
            : []
        }
        handleClose={handleModalClose} 
        handleShow={handleModalShow}
        showModal={showAddSiteAssetModal}
        sudoSiteId={sudoSiteId}
        localAssetId={categoryId}
        mctClusterId={mctClusterId}
        mobileAppId={mobileAppId}
        categoryCustomFields={categoryCustomFields}
      />
    </>
  )
}

export default AddAssetCompany
